import axios from 'axios'
import * as types from '../mutation-types'

// namespaced
export const namespaced = true

// state
export const state = {
  msg: null,
  user: null,
  token: (localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined')
    ? localStorage.getItem('token')
    : null,
  addresses: [],
  customSets: [],
  reservations: [],
  loginByMemberToken: false
}

// getters
export const getters = {
  authMsg: state => state.msg,
  user: state => state.user,
  token: state => state.token,
  authenticated: state => state.user !== null,
  hasAnyMember: state => state.user !== null && state.user.members.length > 0,
  addresses: state => state.addresses,
  customSets: state => state.customSets,
  reservations: state => state.reservations,
  loginByMemberToken: state => state.loginByMemberToken
}

// mutations
export const mutations = {
  [types.SET_AUTH_MSG] (state, msg) {
    const msgs = {
      user: 'Failed to fetch user data',
      profile: 'Failed to update user profile',
      register: 'Failed to register',
      login: 'Failed to login',
      address1: 'address_saved_fail_notice',
      custom_set1: 'custom_set_saved_fail_notice',
      reservation1: 'reservation_saved_fail_notice'
    }
    const message = msg ? (msgs[msg] ? msgs[msg] : msg) : 'Failed to fetch data'
    state.msg = message
  },

  [types.RESET_AUTH_MSG] (state) {
    state.msg = null
  },

  [types.SAVE_TOKEN] (state, { token, remember }) {
    state.token = token
    if (remember) localStorage.setItem('token', token)
  },

  [types.FETCH_USER] (state, user) {
    state.user = user
  },

  [types.CLEAR_USER] (state) {
    state.user = null
    state.token = null
    localStorage.removeItem('token')
    state.addresses = []
    state.customSets = []
    state.reservations = []
    state.loginByMemberToken = false
  },

  [types.LOGOUT] (state) {
    state.user = null
    state.token = null
    localStorage.removeItem('token')
    state.addresses = []
    state.customSets = []
    state.reservations = []
    state.loginByMemberToken = false
    // localStorage.removeItem('vuex')
  },

  [types.UPDATE_USER] (state, user) {
    state.user = Object.assign({}, state.user, user)
  },

  [types.UPDATE_USER_POINTS] (state, points) {
    // const newPoints = parseInt(state.user.points) - parseInt(points)
    const newPoints = parseFloat(state.user.points) - parseFloat(points)
    state.user = Object.assign({}, state.user, { points: newPoints })
  },

  [types.RESET_USER_ADDRESSES] (state) {
    state.addresses = []
  },

  [types.FETCH_USER_ADDRESSES] (state, addresses) {
    state.addresses = addresses
  },

  [types.ADD_USER_ADDRESS] (state, payload) {
    state.addresses.push(payload)
  },

  [types.UPDATE_USER_ADDRESS] (state, payload) {
    const i = state.addresses.findIndex(a => parseInt(a.id) === parseInt(payload.id))
    if (i !== -1) {
      state.addresses[i] = payload
    }
  },

  [types.RESET_USER_CUSTOM_SETS] (state) {
    state.customSets = []
  },

  [types.FETCH_USER_CUSTOM_SETS] (state, customSets) {
    state.customSets = customSets
  },

  [types.ADD_USER_CUSTOM_SET] (state, payload) {
    state.customSets.unshift(payload)
  },

  [types.UPDATE_USER_CUSTOM_SET] (state, payload) {
    const i = state.customSets.findIndex(a => parseInt(a.id) === parseInt(payload.id))
    if (i !== -1) {
      state.customSets[i] = payload
    }
  },

  [types.RESET_USER_RESERVATIONS] (state) {
    state.reservations = []
  },

  [types.FETCH_USER_RESERVATIONS] (state, reservations) {
    state.reservations = reservations
  },

  [types.ADD_USER_RESERVATION] (state, payload) {
    state.reservations.push(payload)
  },

  [types.SET_LOGIN_BY_MEMBER_TOKEN] (state) {
    state.loginByMemberToken = true
  },

  [types.RESET_LOGIN_BY_MEMBER_TOKEN] (state) {
    state.loginByMemberToken = false
  }
}

// actions
export const actions = {
  saveToken ({ commit }, payload) {
    // payload is { token, remember }
    commit(types.SAVE_TOKEN, payload)
  },
  saveUser ({ commit }, payload) {
    // payload is user
    commit(types.FETCH_USER, payload)
  },
  async fetchUser ({ commit, rootGetters }) {
    commit(types.RESET_AUTH_MSG)
    try {
      const { data } = await axios.post('/api/users/me', {
        loyalty_group_id: parseInt(rootGetters['config/loyaltyGroupId'])
      })
      if (data.code === 1) {
        commit(types.FETCH_USER, data.user)
      }
    } catch (e) {
      commit(types.CLEAR_USER)
      commit(types.SET_AUTH_MSG, 'user')
    }
  },
  async updateProfile ({ commit }, payload) {
    commit(types.RESET_AUTH_MSG)
    try {
      const { data } = await axios.post('/api/users/update', { user: payload })
      commit(types.UPDATE_USER, data)
    } catch (e) {
      commit(types.SET_AUTH_MSG, 'profile')
    }
  },
  async updateUser ({ commit }, payload) {
    // payload is user
    commit(types.RESET_AUTH_MSG)
    commit(types.UPDATE_USER, payload)
  },
  async updateUserPoints ({ commit }, payload) {
    // payload is points
    commit(types.RESET_AUTH_MSG)
    commit(types.UPDATE_USER_POINTS, payload)
  },
  async logout ({ commit }) {
    try {
      if (state.token) {
        await axios.post('/api/logout')
      }
    } catch (e) { }

    commit(types.LOGOUT)
  },
  async fetchOauthUrl (ctx, { provider }) {
    const { data } = await axios.post(`/api/oauth/${provider}`)
    if (data.url) {
      return data.url
    }
    return data.msg
  },
  resetUser ({ commit }) {
    commit(types.CLEAR_USER)
  },
  async fetchAddresses ({ commit }) {
    try {
      const { data } = await axios.post('/api/users/addresses')
      if (data.addresses) {
        commit(types.FETCH_USER_ADDRESSES, data.addresses)
      } else {
        commit(types.RESET_USER_ADDRESSES)
      }
    } catch (e) {
      commit(types.RESET_USER_ADDRESSES)
    }
  },
  async addAddress ({ commit }, payload) {
    commit(types.RESET_AUTH_MSG)
    try {
      const { data } = await axios.post('/api/users/address/add', {
        address: payload
      })
      commit(types.ADD_USER_ADDRESS, data)
    } catch (e) {
      commit(types.SET_AUTH_MSG, 'address1')
    }
  },
  async editAddress ({ commit }, payload) {
    commit(types.RESET_AUTH_MSG)
    try {
      const { data } = await axios.post('/api/users/address/edit', {
        address: payload
      })
      if (data) {
        commit(types.UPDATE_USER_ADDRESS, data)
      } else {
        commit(types.SET_AUTH_MSG, 'address1')
      }
    } catch (e) {
      commit(types.SET_AUTH_MSG, 'address1')
    }
  },
  async setDefaultAddress ({ commit }, payload) {
    commit(types.RESET_AUTH_MSG)
    try {
      const { data } = await axios.post('/api/users/address/default', {
        id: payload
      })
      if (data) {
        commit(types.FETCH_USER_ADDRESSES, data)
      } else {
        commit(types.SET_AUTH_MSG, 'address1')
      }
    } catch (e) {
      commit(types.SET_AUTH_MSG, 'address1')
    }
  },
  async deleteAddress ({ commit }, payload) {
    commit(types.RESET_AUTH_MSG)
    try {
      const { data } = await axios.post('/api/users/address/delete', {
        id: payload
      })
      if (data) {
        commit(types.FETCH_USER_ADDRESSES, data)
      } else {
        commit(types.SET_AUTH_MSG, 'address1')
      }
    } catch (e) {
      commit(types.SET_AUTH_MSG, 'address1')
    }
  },
  async fetchCustomSets ({ commit, rootGetters }) {
    try {
      const { data } = await axios.post('/api/users/custom_sets', {
        loyalty_group_id: parseInt(rootGetters['config/loyaltyGroupId']),
        restaurant_id: parseInt(rootGetters['config/rid']) === 0 ? parseInt(rootGetters['config/rid2']) : parseInt(rootGetters['config/rid'])
      })
      if (data.custom_sets) {
        commit(types.FETCH_USER_CUSTOM_SETS, data.custom_sets)
      } else {
        commit(types.RESET_USER_CUSTOM_SETS)
      }
    } catch (e) {
      commit(types.RESET_USER_CUSTOM_SETS)
    }
  },
  async addCustomSet ({ commit, rootGetters }, payload) {
    commit(types.RESET_AUTH_MSG)
    try {
      const { data } = await axios.post('/api/users/custom_set/add', {
        loyalty_group_id: parseInt(rootGetters['config/loyaltyGroupId']),
        restaurant_id: parseInt(rootGetters['config/rid']) === 0 ? parseInt(rootGetters['config/rid2']) : parseInt(rootGetters['config/rid']),
        custom_set: payload
      })
      commit(types.ADD_USER_CUSTOM_SET, data)
    } catch (e) {
      commit(types.SET_AUTH_MSG, 'custom_set1')
    }
  },
  async editCustomSet ({ commit }, payload) {
    commit(types.RESET_AUTH_MSG)
    try {
      const { data } = await axios.post('/api/users/custom_set/edit', { custom_set: payload })
      if (data) {
        commit(types.UPDATE_USER_CUSTOM_SET, data)
      } else {
        commit(types.SET_AUTH_MSG, 'custom_set1')
      }
    } catch (e) {
      commit(types.SET_AUTH_MSG, 'custom_set1')
    }
  },
  async deleteCustomSet ({ commit, rootGetters }, payload) {
    commit(types.RESET_AUTH_MSG)
    try {
      const { data } = await axios.post('/api/users/custom_set/delete', {
        loyalty_group_id: parseInt(rootGetters['config/loyaltyGroupId']),
        restaurant_id: parseInt(rootGetters['config/rid']) === 0 ? parseInt(rootGetters['config/rid2']) : parseInt(rootGetters['config/rid']),
        id: payload
      })
      if (data) {
        commit(types.FETCH_USER_CUSTOM_SETS, data)
      } else {
        commit(types.SET_AUTH_MSG, 'custom_set1')
      }
    } catch (e) {
      commit(types.SET_AUTH_MSG, 'custom_set1')
    }
  },
  async fetchReservations ({ commit, rootGetters }) {
    try {
      const { data } = await axios.post('/api/users/reservations', {
        loyalty_group_id: parseInt(rootGetters['config/loyaltyGroupId']),
        restaurant_id: parseInt(rootGetters['config/rid']) === 0 ? parseInt(rootGetters['config/rid2']) : parseInt(rootGetters['config/rid'])
      })
      if (data.reservations) {
        commit(types.FETCH_USER_RESERVATIONS, data.reservations)
      } else {
        commit(types.RESET_USER_RESERVATIONS)
      }
    } catch (e) {
      commit(types.RESET_USER_RESERVATIONS)
    }
  },
  async addReservation ({ commit, rootGetters }, payload) {
    commit(types.RESET_AUTH_MSG)
    try {
      const restaurantId = parseInt(rootGetters['config/rid']) === 0 ? parseInt(rootGetters['config/rid2']) : parseInt(rootGetters['config/rid'])
      const loyaltyGroupId = parseInt(rootGetters['config/loyaltyGroupId'])
      const { data } = await axios.post('/api/users/reservation/add', {
        loyalty_group_id: loyaltyGroupId,
        restaurant_id: restaurantId,
        reservation: { ...payload,
          event_id: rootGetters['config/reservationConfig'].eventId,
          cashier_id: rootGetters['config/reservationConfig'].cashierId
        }
      })
      if (data.code === 1) {
        commit(types.ADD_USER_RESERVATION, data.reservation)
      } else {
        commit(types.SET_AUTH_MSG, 'reservation1')
      }
    } catch (e) {
      commit(types.SET_AUTH_MSG, 'reservation1')
    }
  },
  async memberTokenLogin ({ commit, rootGetters, dispatch }) {
    const { data } = await axios.get('/api/memberTokenLogin')
    await dispatch('saveToken', {
      token: data,
      remember: true
    })
    await dispatch('fetchUser')
    await dispatch('member/fetchProfile', null, {root: true})
    await dispatch('fetchMembershipInfo', null, {root: true})
    commit(types.SET_LOGIN_BY_MEMBER_TOKEN)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js